import React from 'react';

const ProductGrid = ({
  products = [],
  selectedCategory = 'All',
  searchQuery = '',
  onAddToCart,
  onCategoryChange
}) => {
  // Safely filter products
  const filteredProducts = products.filter(product => {
    if (!product) return false;
    
    // Handle category comparison (category is an object)
    const categoryMatch = selectedCategory === 'All' || 
                         (product.category && 
                          (typeof product.category === 'string' ? 
                           product.category === selectedCategory :
                           product.category._id === selectedCategory._id));
    
    const searchMatch = product.name && 
                       product.name.toLowerCase().includes(searchQuery.toLowerCase());
    
    return categoryMatch && searchMatch;
  });

  // Get unique categories safely
  const getCategoryName = (category) => {
    if (!category) return '';
    return typeof category === 'string' ? category : category.name || category._id;
  };

  const categories = [
    'All',
    ...new Set(
      products
        .filter(p => p?.category)
        .map(p => p.category)
    )
  ];

  return (
    <div>
      {/* Category selector - now handles object categories */}
      <div className="flex space-x-2 mb-4 overflow-x-auto pb-2">
        {categories.map(category => {
          const categoryId = category === 'All' ? 'All' : 
                           (typeof category === 'string' ? category : category._id);
          const displayName = category === 'All' ? 'All' : getCategoryName(category);
          
          return (
            <button
              key={categoryId}
              onClick={() => onCategoryChange(category)}
              className={`px-4 py-2 rounded-full whitespace-nowrap ${
                (selectedCategory === 'All' && category === 'All') ||
                (category !== 'All' && selectedCategory?._id === category?._id)
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-200 text-gray-800'
              }`}
            >
              {displayName}
            </button>
          );
        })}
      </div>

      {/* Products grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {filteredProducts.map(product => (
          <div
            key={product._id}
            className="bg-white rounded-lg shadow p-4 cursor-pointer hover:shadow-md transition-shadow"
            onClick={() => onAddToCart(product)}
          >
            <h3 className="font-medium mb-1">{product.name}</h3>
            <p className="text-gray-600">{product.price.toFixed(2)}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductGrid;